<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container">
      <div v-if="loading" class="text-center">
        <div class="spinner-border" role="status"></div>
      </div>

      <div v-else-if="survey && currentQuestion">
        <h3 class="text-center mb-3">{{ survey.survey_title }}</h3>
        <p class="text-center">{{ survey.survey_guidelines }}</p>

        <div class="card mt-4">
          <div class="card-body">
            <h5>Pergunta {{ currentIndex + 1 }} de {{ questions.length }}</h5>
            <p>{{ currentQuestion.sq_question }}</p>

            <div v-if="currentQuestion.options.length" class="list-group">
              <label
                v-for="option in currentQuestion.options"
                :key="option.id_so"
                class="list-group-item"
              >
                <input
                  type="radio"
                  :name="'question_' + currentQuestion.id_sq"
                  :value="option.so_text"
                  v-model="answers[currentQuestion.id_sq]"
                  @change="setOptionValue(currentQuestion.id_sq, option)"
                  class="form-check-input me-2"
                />
                {{ option.so_text }}
              </label>
            </div>

            <div v-else class="mb-3">
            <textarea
              v-model="answers[currentQuestion.id_sq]"
              class="form-control"
              rows="3"
              placeholder="Digite sua resposta..."
            ></textarea>
            </div>

            <button
              class="btn btn-primary w-100 mt-3"
              :disabled="!answers[currentQuestion.id_sq]"
              @click="nextQuestion"
            >
              {{ isLastQuestion ? 'Finalizar' : 'Próxima' }}
            </button>
          </div>
        </div>
      </div>

      <div v-else-if="finished" class="text-center">
        <h4>Obrigado por responder a pesquisa!</h4>
      </div>

      <div v-else class="text-center">
        <p class="text-danger">Pesquisa não encontrada, expirada ou já foi respondida.</p>
      </div>
    </div>
  </section>
</template>

<script>
import http from "../../helpers/http";
import Alert from "@/helpers/alert";

export default {
  name: 'SurveyAnswer',
  data() {
    return {
      token: this.$route.params.token,
      survey: null,
      patient: null,
      questions: [],
      currentIndex: 0,
      answers: {},
      loading: true,
      finished: false,
      optionValues: {},
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentIndex];
    },
    isLastQuestion() {
      return this.currentIndex === this.questions.length - 1;
    },
  },
  mounted() {
    this.fetchSurvey();
  },
  methods: {
    setOptionValue(id_sq, option) {
      this.optionValues[id_sq] = option.so_value;
      this.answers[id_sq] = option.so_text;
    },
    fetchSurvey() {
      http
        .get(`/survey/${this.token}`)
        .then(response => {
          this.survey = response.data.survey;
          this.patient = response.data.patient;
          this.questions = response.data.survey.questions.map(q => ({
            ...q,
            options: q.options || [],
          }));
        })
        .catch(err => {
          Alert.error('Falha ao buscar pesquisa.')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    nextQuestion() {
      if (this.isLastQuestion) {
        this.submitAnswers();
      } else {
        this.currentIndex++;
      }
    },
    submitAnswers() {
      const payload = {
        id_survey: this.survey.id_survey,
        id_patient: this.patient.id_patient,
        id_st: this.survey.id_st,
        answers: this.questions.map(q => ({
          id_sq: q.id_sq,
          sa_answer: q.options.length ? null : this.answers[q.id_sq] || '',
          sa_option_text: q.options.length ? this.answers[q.id_sq] : null,
          sa_option_value: q.options.length ? this.optionValues[q.id_sq] : null
        }))
      };

      http
        .post(`/survey/${this.token}`, payload)
        .then(() => {
          this.finished = true;

          this.$router.push('/survey/success');
        })
        .catch(err => {
          Alert.error('Erro ao enviar respostas', err);
        });
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 600px;
  margin: 0 auto;
}

@media (max-width: 576px) {
  .card {
    margin: 0 1rem;
  }
}
</style>